import { AnimatePresence, motion } from 'motion/react';
import React, { useState } from 'react';
import { FaTriangleExclamation, FaXmark } from 'react-icons/fa6';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { unsubApi } from '../http/http';
import classes from './UnsubModal.module.css';

const UnsubModal = ({ t, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    if (loading) return;
    onClose();
  };

  const confirmUnsubscribe = async () => {
    const token = Cookies.get('token');
    if (!token) {
      onClose();
      navigate('/');
      return;
    }

    setLoading(true);
    try {
      await unsubApi(token);
      Cookies.remove('token');
      onClose();
      navigate('/');
    } catch (err) {
      console.log(err);
      toast.error(t.errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className={classes.modalOverlay}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={closeModal}
      >
        <motion.div
          className={classes.modalBox}
          initial={{ opacity: 0, y: 30, scale: 0.94 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.96 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <FaXmark />
          </button>

          <div className={classes.modalIconWrap}>
            <FaTriangleExclamation />
          </div>

          <h3 className={classes.modalTitle}>{t.unsubTitle}</h3>
          <p className={classes.modalText}>{t.unsubText}</p>

          <div className={classes.modalActions}>
            <button className={classes.modalCancelBtn} onClick={closeModal}>
              {t.unsubCancel}
            </button>
            <button
              className={classes.modalConfirmBtn}
              onClick={confirmUnsubscribe}
              disabled={loading}
            >
              {loading ? (
                <span className={classes.spinner} />
              ) : (
                t.unsubConfirm
              )}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UnsubModal;
